import { motion } from "framer-motion";
import { cn } from "../lib/utils";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-90px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className }) => (
  <span
    className={cn(
      "font-mono text-xs tracking-[0.22em] uppercase text-brand",
      className
    )}
  >
    {children}
  </span>
);
